import React from 'react';

var _path;

var SvgCapturePaymentMinor = function SvgCapturePaymentMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9a2 2 0 1 1-.001 4.001A2 2 0 0 1 15 9zm-5 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 10 9zm6-7a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 2zm-3 14a1 1 0 1 1 0 2H7a.998.998 0 0 1-.243-.03l-4-1A1 1 0 0 1 2 16v-3c0-.431.275-.813.684-.948l3-1a.947.947 0 0 1 .294-.047C5.985 11.004 5.992 11 6 11h3a1 1 0 1 1 0 2H7.166c.599 1.807 2.828 3 5.834 3z"
  })));
};

export { SvgCapturePaymentMinor as S };
